<top-banner variant="title" [title]="routeParams"></top-banner>

<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body mb-2">

          <ng-container *ngFor="let question of questionsArray; let i = index">
            <div class="form-row">
              <div class="col-md-12">
                <div class="form-group" class="edit-question_form-group">

                  <p-accordion>
                    <p-accordionTab [header]="'Q' + (i + 1)" [selected]="isExpanded">
                      <ng-container class="row">
                        <div class="d-flex align-items-baseline edit-question_accordionTab">
                          <label class="edit-question_accordionTab_label">Question: </label>
                          <input
                          type="text"
                          class="form-control edit-question_accordionTab_input"
                          [value]="question.question.text"
                          (change)="editQuestion($event.currentTarget.value, question, i)"
                          placeholder="Question..." />
                        </div>
                      </ng-container>

                      <ng-container *ngFor="let answer of question.answers; let j = index">
                        <div class="d-flex align-items-baseline edit-question_answer">
                          <input
                          type="text"
                          class="form-control edit-question_accordionTab_input"
                          [value]="answer.text"
                          (change)="editAnswer($event.currentTarget.value, question, answer, i, j)"
                          placeholder="Option... " />
                          <div class="d-flex">
                            <p-checkbox
                              class="p-2"
                              binary="true"
                              [(ngModel)]="answer.correct"
                              (onChange)="setAnswerAsCorrect($event.checked, question, answer, i, j)"
                            ></p-checkbox>
                            <button type="button" class="close p-2" (click)="removeAnswer(question, answer)"><span class="pi pi-times"></span></button>
                          </div>
                        </div>
                      </ng-container>
                      <button type="button" class="btn btn-round btn-sm btn-warning" (click)="removeQuestion(question)">
                        <i class="fas fa-x"></i>
                        &nbsp;
                        Delete</button>
                      <button type="button" class="btn btn-round btn-sm btn-primary mr-2" (click)="addAnswer(question)">
                        <i class="fas fa-plus"></i>
                        &nbsp;
                        Add answer
                      </button>
                    </p-accordionTab>
                  </p-accordion>
                </div>
              </div>
            </div>
          </ng-container>

          <div class="col-md-12">
            <button type="button" class="btn btn-block btn-primary" (click)="addQuestion()">
              <i class="fas fa-plus"></i>
              &nbsp;
              <strong>CREATE NEW QUESTION</strong>
            </button>
          </div>

          <div class="d-flex justify-content-end mt-5">
            <button type="button" (click)="cancel()" class="my-2 btn btn-round btn-sm btn-default">Cancel</button>
            <button type="button" (click)="saveQuestions()" class="my-2 btn btn-round btn-sm btn-success">Save</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
